'use client';
import type { ComponentProps } from 'react';
import {
  MultiTierGift as SharedMultiTierGift,
  MultiTierGiftView as SharedMultiTierGiftView,
} from '@eliadmin/core/src/components/product/detail/multi-tier-gift-base';
import { ProjectGiftSurface } from '@eliadmin/core/src/components/product/detail/project-gift-surface';
export function MultiTierGift(props: ComponentProps<typeof SharedMultiTierGift>) {
  return (
    <ProjectGiftSurface context="product">
      <SharedMultiTierGift {...props} />
    </ProjectGiftSurface>
  );
}
export function MultiTierGiftView(props: ComponentProps<typeof SharedMultiTierGiftView>) {
  return (
    <ProjectGiftSurface context="product">
      <SharedMultiTierGiftView {...props} />
    </ProjectGiftSurface>
  );
}
